module.exports = __webpack_public_path__ + "static/media/home.1e660547.svg";